(function () {
'use strict';

angular.module('hyresgastApp').controller('NewAgreementRentlistCtrl', NewAgreementRentlistCtrl);

function NewAgreementRentlistCtrl($scope, $location, $routeParams, $uibModal, $timeout,
  Agreement, Auth, Flash, HyUtils, ErrorHandler) {
  var vm = this;
  vm.agreement = {
    negotiationId: $routeParams.negotiationId,
    id: $routeParams.id,
    documents: []
  };

  vm.showAdditionalInfoPane = false;
  vm.save = save;
  vm.toggleAdditionalInfoPane = toggleAdditionalInfoPane;
  vm.onPending = onPending;
  vm.gotoNextStep = gotoNextStep;
  vm.getColumnTitle = title => title instanceof Array ? title[0] : title.split(',')[0].trim();

  // The wizard uses a file upload directive and the directive is validating the content
  // of uploaded files (excel). If the file upload directive receives errors from the backend
  // we want to open a modal to show the errors to the user
  $scope.$watch('vm.validationResponse', function(validationResponse) {
    if (validationResponse) {
      vm.status = validationResponse;
      if (vm.validationResponse.status === 'ok') {
        vm.status.phase = 'Success';
        vm.status.comment = '';
        vm.inputRentListBlobId = vm.agreement.rentListBlobId;
      } else if (vm.validationResponse.status === 'error') {
        vm.uploader.cancelUpload();
        HyUtils.showDefaultModal('ErrorModalCtrl', 'resources/validation/errors.html', {
          validationResponse, realEstateChoiceMethod: null,
        });
      } else {
        vm.uploader.cancelUpload();
      }
    } else {
      vm.status = {
        phase: 'read excel file',
        total: 0,
        errors: 0,
        warnings: 0,
        progress: 0,
        showProgress: false,
      };
    }
  });

  ////////////
  function toggleAdditionalInfoPane() {
    vm.showAdditionalInfoPane = !vm.showAdditionalInfoPane;
  }

  function onPending(validation) {
    if (vm.status.showProgress && vm.status.progress > 0 && vm.status.phase !== validation.phase) {
      vm.status.progress = 100;
      $timeout(() => {
        vm.status.progress = 0;
        vm.status.phase = validation.phase;
        vm.status.comment = validation.comment;
        $timeout(() => vm.status = validation, 500);
      }, 300);

    } else {
      vm.status = validation;
    }
  }

  function save() {
    vm.saving = true;
    Agreement.importRentlist(vm.agreement)
      .$promise.then(
        // eslint-disable-next-line no-unused-vars
        function(response) {
          $location.search({}); // remove parameters set by wizard
          $location.path('/negotiations/' + vm.agreement.negotiationId + '/agreements/' + vm.agreement.id);
          Flash.set('Hyreslista har laddats upp', 'success');
        })
      .catch(new ErrorHandler('Misslyckades att ladda upp hyreslista.'))
      .finally(function() {
        vm.saving = false;
      });
  }

  function gotoNextStep() {
    vm.gotoNext = true;
  }
}

})();